import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Observable, merge, from, of } from 'rxjs';
import { startWith, switchMap, map, catchError } from 'rxjs/operators';
import { FullClientUser } from 'src/models/ClientUser';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-admin-accounts',
  templateUrl: './admin-accounts.component.html',
  styleUrls: ['./admin-accounts.component.scss']
})
export class AdminAccountsComponent implements OnInit {
  displayedColumns: string[] = ['name', 'email', 'approved'];
  filteredAndPaged: Observable<FullClientUser[]>;

  resultsLength = 0;
  isLoadingResults = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private api: ApiService, private router: Router) { }

  updateData() {
    this.filteredAndPaged = merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return from(this.api.adminGetAllClientUsers());//this.sort.active, this.sort.direction=='desc', this.paginator.pageSize, this.paginator.pageIndex));
        }),
        map(data => {
          this.isLoadingResults = false; 
          return data;
        }),
        catchError(e => {
          //todo: error msg
          this.isLoadingResults = false;
          return of([]);
        })
    )
  }
  ngAfterViewInit() {
    this.updateData();
  }
  addBusiness() {
    this.router.navigate(['/retailers', 'new']);
  }
  resetPaging(): void {
    this.paginator.pageIndex = 0;
  }
  ngOnInit(): void {
  }

}
